module.exports = __webpack_public_path__ + "img/WorkTimeDialog.718de41b.png";